import {RequiredRule, Validator} from 'devextreme-react/validator';
import {DateBox} from 'devextreme-react/date-box';
import {useContext} from 'react';
import {Field, Panel} from '../../../../layouts';
import {AR, QuoteStatus} from '../../../../types/enums';
import {EstimateContext} from '../context/EstimateContext';

export default function CustomerContactDatePanel() {

	const { order, modifyOrder } = useContext(EstimateContext);

	const isOrderReadonly = order.details.statusID === QuoteStatus.Closed ||
		order.details.statusID === QuoteStatus.Cancelled || order.details.statusID === QuoteStatus.Expired;

	const isReadOnly = !order.details.activeARs.includes(AR.LeadContactCustomer) || isOrderReadonly;
	const isRequired = !isReadOnly;

	return (
		<Panel header={'Dates'} >

			<Field label="Customer Contact Date" >
				<DateBox value={order.details.customerContactDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, customerContactDate: e.value })}
					readOnly={isReadOnly}
					max={new Date()}
					className={isRequired ? 'required' : ''}>
					<Validator>
						{isRequired && order.modified &&
							<RequiredRule message={'Customer Contact Date is required'} />}
					</Validator>
				</DateBox>
			</Field>
		</Panel>
	);
}
